import { render, staticRenderFns } from "./TheContainer.vue?vue&type=template&id=2af477d8&scoped=true&"
import script from "./TheContainer.vue?vue&type=script&lang=js&"
export * from "./TheContainer.vue?vue&type=script&lang=js&"
import style0 from "./TheContainer.vue?vue&type=style&index=0&id=2af477d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af477d8",
  null
  
)

export default component.exports